import { MESSAGE_LOCALES, type MessageLocale } from '@/contract'

/* Spec PARTNER-005 D-02 — resolucao do idioma (copia adaptada de sponsor-app/src/i18n/locale.ts, PWA-001).
   Funcoes puras: a leitura do aparelho (localStorage, navigator.languages) fica em quem chama. Os 5 idiomas da
   interface sao os mesmos das mensagens (C#1, uma escolha so). */

export const SUPPORTED_LOCALES = MESSAGE_LOCALES
export type Locale = MessageLocale
export const DEFAULT_LOCALE: Locale = 'pt-BR'
export const LANGUAGE_STORAGE_KEY = 'partner-language'

export function isLocale(value: unknown): value is Locale {
    return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

/* Lista de idiomas do navegador (navigator.languages) para um dos 5. Casa exato (pt-BR) e depois pelas duas letras
   (pt-PT → pt-BR, en-GB → en-US). Sem casamento ⇒ pt-BR. */
export function resolveDeviceLocale(candidates: readonly string[]): Locale {
    for (const raw of candidates) {
        const candidate = raw.trim()
        const exact = SUPPORTED_LOCALES.find(l => l.toLowerCase() === candidate.toLowerCase())
        if (exact) return exact
        const base = candidate.split('-')[0]?.toLowerCase()
        const byBase = SUPPORTED_LOCALES.find(l => l.split('-')[0]!.toLowerCase() === base)
        if (byBase) return byBase
    }
    return DEFAULT_LOCALE
}

/* O salvo no aparelho vence o idioma do navegador. Valor invalido e ignorado. */
export function resolveInitialLocale(stored: string | null, deviceCandidates: readonly string[]): Locale {
    return isLocale(stored) ? stored : resolveDeviceLocale(deviceCandidates)
}
